export default "__VITE_ASSET__BzYSmghh__"